<template>
    <div>
        <b-row class="marginal">
          <b-col cols="auto">
              <h3 class="h3">Global Analytics</h3>
          </b-col>
        </b-row>
  
        <b-row class="justify-content-center">
            <b-col cols="auto">
              <h4>Data consumed since the beginning of the month: <strong class="text-green">{{dataMonth2}}</strong></h4>
            </b-col>
      </b-row>
  
      <!--<b-row  class="justify-content-center">
          <b-col class="col-9">
            <b-progress :max="250 * 1000000" height="2rem">
              <b-progress-bar :value="dataMonth" animated variant="success">
                  Progress: <strong>{{ Math.round(dataMonth / 10000) / 100}} / {{ 250 }} TB</strong>
              </b-progress-bar>
          </b-progress>
          </b-col>
      </b-row>-->
  
      <b-row>
          <b-card
                  title="Videos:"
                  class="analyticscard col-xl-6 col-md-12"
              >
              <b-row class="justify-content-center">
                  <b-col class="col-md-4 col-6" style="height: 300px;">
                      <canvas id="videoLiveChart" height="100%"></canvas>
                  </b-col>
                  <b-col class="col-md-4 col-6" style="height: 300px;">
                      <canvas id="videoVodChart" width="100%"></canvas>
                  </b-col>
                  <b-col class="col-md-4 col-6" style="height: 300px;">
                      <canvas id="videoAllChart" width="100%"></canvas>
                  </b-col>
              </b-row>
          </b-card>
  
              <b-card
              title="Cameras"
              class="analyticscard col-xl-6 col-md-12"
              >
                  <b-row>
                      <b-col class="col-md-3 col-6" style="height: 300px;">
                          <canvas id="cameraLiveChart" width="100%" ></canvas>
                      </b-col>
                      <b-col class="col-md-3 col-6" style="height: 300px;">
                          <canvas id="cameraVodChart" width="100%"></canvas>
                      </b-col>
                      <b-col class="col-md-3 col-6" style="height: 300px;">
                          <canvas id="cameraBothChart" width="100%"></canvas>
                      </b-col>
                      <b-col class="col-md-3 col-6" style="height: 300px;">
                          <canvas id="cameraAllChart" width="100%"></canvas>
                      </b-col>
                  </b-row>
              </b-card>
  
        </b-row>
  
        <b-row>
          <b-card
            title="Best Cameras"
            sub-title="Data computed over the last 24 hours. Rebuffering % and offload % over the last 1 hour. Data are refreshed every 30min."
            class="analyticscard col-12"
          >
          <b-row class="justify-content-center" align-h="around">
                  <b-dropdown id="dropdown-2" v-bind:text="activeAction2" variant="quanteec">
                      <b-dropdown-item v-bind:class="{ active : isActive2===7}" @click="changeIsActive2(action7)">{{action7}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===1}" @click="changeIsActive2(action1)">{{action1}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===2}" @click="changeIsActive2(action2)">{{action2}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===3}" @click="changeIsActive2(action3)">{{action3}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===4}" @click="changeIsActive2(action4)">{{action4}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===5}" @click="changeIsActive2(action5)">{{action5}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===6}" @click="changeIsActive2(action6)">{{action6}}</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : isActive2===8}" @click="changeIsActive2(action8)">{{action8}}</b-dropdown-item>
                  </b-dropdown>
  
                  <b-dropdown id="dropdown-3" v-bind:text="numberOfCameras + ' camera per page'" variant="quanteec">
                      <b-dropdown-item v-bind:class="{ active : numberOfCameras===10}" @click="pageBestCameras=1;numberOfCameras=10;changeIsActive2()">10 per page</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : numberOfCameras===20}" @click="pageBestCameras=1;numberOfCameras=20;changeIsActive2()">20 per page</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : numberOfCameras===50}" @click="pageBestCameras=1;numberOfCameras=50;changeIsActive2()">50 per page</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : numberOfCameras===100}" @click="pageBestCameras=1;numberOfCameras=100;changeIsActive2()">100 per page</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : numberOfCameras===500}" @click="pageBestCameras=1;numberOfCameras=500;changeIsActive2()">500 per page</b-dropdown-item>
                  </b-dropdown>
  
                  <b-dropdown id="dropdown-4" v-bind:text="'1 ' + intervalBestCameras + ' interval'" variant="quanteec">
                      <b-dropdown-item v-bind:class="{ active : intervalBestCameras==='hour'}" @click="pageBestCameras=1;intervalBestCameras='hour';changeIsActive2()">1 hour interval</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : intervalBestCameras==='day'}" @click="pageBestCameras=1;intervalBestCameras='day';changeIsActive2()">1 day interval</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : intervalBestCameras==='week'}" @click="pageBestCameras=1;intervalBestCameras='week';changeIsActive2()">1 week interval</b-dropdown-item>
                      <b-dropdown-item v-bind:class="{ active : intervalBestCameras==='month'}" @click="pageBestCameras=1;intervalBestCameras='month';changeIsActive2()">1 month interval</b-dropdown-item>
                  </b-dropdown>
                  
                  <b-col cols="auto" class="btn-quanteec">
                      <b-row align-v="center">
                          <b-col>
                              Type: 
                          </b-col>
                          <b-col>
                              <b-form-checkbox v-model="filterCameraType.live" @input="changeIsActive2()">Live </b-form-checkbox>
                              <b-form-checkbox v-model="filterCameraType.vod"  @input="changeIsActive2()" >VoD </b-form-checkbox>
                              <b-form-checkbox v-model="filterCameraType.livevod"  @input="changeIsActive2()" >Live+VoD </b-form-checkbox>
                          </b-col>
                      </b-row>
                  </b-col>
              </b-row>
              <b-row v-if="isGetInProgress" class="marginal">
                  <div class="col-md-6"></div>
                  <fade-loader color="#00b0ff"></fade-loader>
              </b-row>
              <div style="height:400px">
                  <canvas id="myChart8" height="100%" width="100%"></canvas>
                  
              </div>
              <b-pagination align="center" :limit="10" :total-rows="maxPageBestCameras" v-model="pageBestCameras" :per-page="1" @input="changeIsActive2()">
                  </b-pagination>
  
          </b-card>
        </b-row>
    </div>
  </template>
  
  <script>
  //TODO : Graph Total number of
  //TODO : Key Type
  //TODO : Time Encoding
  
  import AnalyticsService from "@/services/analytics.service";
  import AuthorizationKeyService from "@/services/authorizationKey.service";
  import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
  import { Chart } from "chart.js";
  import 'chartjs-plugin-labels';
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import VideoService from "@/services/video.service";
  import UserService from "@/services/user.service";
  
  var analyticsService = new AnalyticsService();
  var authorizationKeyService = new AuthorizationKeyService();
  var videoService = new VideoService();
  var userService = new UserService();
  export default {
    name: 'vsgraph',
    data: function() {
        return {
              dataMonth: 0,
              userView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyView() || this.$auth.getMyUser().username : this.$auth.getMyUser().username,
              clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
              numberOfCameras: 20,
              pageBestCameras: 1,
              maxPageBestCameras: 29,
              filterCameraType: {
                  live: true,
                  vod: true,
                  livevod: true
              },
              filterCameraTypeIframe: 'All',
              iframesrc: '',
              iframesrcComplete: '',
              date: '',
              test:0,
              isActive:7,
              activeAction:"Data delivered",
              isActive2:7,
              activeAction2:"Data delivered",
              action1:"Views",
              action2:"Viewing hours",
              action3:"Average viewing time",
              action4:"Rebuff %",
              action5:"Offload %",
              action6:"Average bitrate",
              action7:"Data delivered",
              action8:"Encoding errors",
              totNbVues:0,
              sec_peer:1,
              sec_server:1,
              totDataDelivered:0,
              totHoursView:0,
              minuteView:0,
              percent_rebuf:0,
              percent_off:0,
              livePassthrough:0,
              liveEncodings:0,
              VODPassthrough:0,
              VODEncodings:0,
              totalVideo:190,
              secVodPassthrough:6443,
              secVodEncoded:3456,
              videoLiveChart: null,
              videoVodChart: null,
              videoAllChart: null,
              cameraLiveChart: null,
              cameraVodChart: null,
              cameraBothChart: null,
              cameraAllChart: null,
              bestCamera:[],
              isGetInProgress:false,
              isGetInProgress2:false,
              keyTypeLiveEncoding: 0,
              keyTypeLivePassthrough: 0,
              keyTypeVodPassthrough: 0,
              keyTypeVodEncoding: 0,
              keyTypeLVPassthrough: 0,
              keyTypeLVEncoding: 0,
              camerasForType: [],
              intervalBestCameras: "day"
        }
    },
    computed: {
        dataMonth2() {
            return (Math.round(this.dataMonth / 10000) / 100) + ' TB';
        }
    },
    mounted() {
  
        // INIT URL IFRAME GLOBAL ANALYTICS
        var baseurl = this.$auth.getMyUser().analyticsUrl || "https://platforms3.joada.net";
        var nameDashboard = this.$auth.getMyUser().analyticsDashboard || "analytics" || "global-analytics";
        var analyticsAddr = `analytics${this.clientView}2`
  
        this.iframesrc = `${baseurl}/${analyticsAddr}/d/${nameDashboard}/${nameDashboard}`
        this.iframesrcComplete = this.iframesrc;
  
        this.getDataMonth();
  
        //INIT EVERY CHART
  
        this.chartVideoLive();
        this.chartVideoVod();
        this.chartVideoAll();
  
        this.chartCameraLive();
        this.chartCameraVod();
        this.chartCameraBoth();
        this.chartCameraAll();
  
        this.chartBestCamera();
        //this.chartWorstCamera();
  
        
        //GET TAB OF BESTS CAMERAS
        this.getBestCameras("Data delivered")
        //this.getWorstCameras("Data delivered")
        
        //GET EVERY NUMBER THAT ARE NOT IN Elasticsearch
        this.getNumberVideoPlatform()
    },
    components: {
        FadeLoader
    },
    methods:{
        getDataMonth() {
            if ((this.$auth.getMyUser().roles.indexOf('admin') > -1)) {
              userService.getClient(this.$auth.token(), this.clientView).then((client) => {
                    this.dataMonth = client.MB_month;
                })
            } else {
                userService.getMyUser(this.$auth.token()).then((user) => {
                    this.dataMonth = user.client_infos[0].MB_month;
                })
            }
        },
        //Show modal if wrong date 
        showModal2(ref) {
          this.$refs[ref].show();
        },
        hideModal2 (ref) {
          this.$refs[ref].hide();
        },
  
        // Maintain the active state of dropdown button for chart Best Cameras
        changeIframe(){
          let filter = {};
          let authorizationKeyPromise;
          if (this.filterCameraTypeIframe === 'Live') {
              filter = {
                  type: "live"
              }
          } else if (this.filterCameraTypeIframe === 'VoD') {
              filter = {
                  type: "vod"
              }
          } else if (this.filterCameraTypeIframe === 'Live + VoD') {
              filter = {
                  type: "live-vod"
              }
          }
  
          if (this.filterCameraTypeIframe !== 'All') {
              if (this.$auth.getMyUser().roles.indexOf('admin') > -1) {
                  filter.client = this.clientView;
                  authorizationKeyPromise = authorizationKeyService.getAuthorizationKeys(this.$auth.token(), {filter: JSON.stringify(filter), pagesize: 700});
              } else {
                  authorizationKeyPromise = authorizationKeyService.getMyAuthorizationKeys(this.$auth.token(), {filter: JSON.stringify(filter), pagesize: 700});
              }
  
              Promise.all([authorizationKeyPromise]).then(([result]) => {
                  let camerasForType = result._embedded.map(x => x.key);
                  let newCameras = [];
                  let resultUrlOptions = '';
                  
                  camerasForType.forEach(elem => {
                      newCameras.push('var-video_id=' + elem);
                  })
                  resultUrlOptions = '?' + newCameras.join('&');
                  this.iframesrcComplete = this.iframesrc + resultUrlOptions;
              }).catch((err) => {
                  console.log(err);
              })
          } else {
              this.iframesrcComplete = this.iframesrc;
          }
          
        },
        // Maintain the active state of dropdown button for chart Worst Cameras
        changeIsActive2(action){
          if (action==="Views"){
              this.isActive2=1
              this.activeAction2="Views"
          }
          else if (action==="Viewing hours"){
              this.isActive2=2
              this.activeAction2="Viewing hours"
          }
          else if (action==="Average viewing time"){
              this.isActive2=3
              this.activeAction2="Average viewing time"
          }
          else if (action==="Rebuff %"){
              this.isActive2=4
              this.activeAction2="Rebuff %"
          }
          else if (action==="Offload %"){
              this.isActive2=5
              this.activeAction2="Offload %"
          }
          else if (action==="Average bitrate"){
              this.isActive2=6
              this.activeAction2="Average bitrate"
          }
          else if (action==="Data delivered"){
              this.isActive2=7
              this.activeAction2="Data delivered"
          } if (action==="Encoding errors"){
              this.isActive2=8
              this.activeAction2="Encoding errors"
          }
          let filter= {
              "$or": []
          };
          if (this.filterCameraType.live) {
              filter["$or"].push({
                  type: "live"
              })
          }
          if (this.filterCameraType.vod) {
              filter["$or"].push({
                  type: "vod"
              })
          } 
          if (this.filterCameraType.livevod) {
              filter["$or"].push({
                  type: "live-vod"
              })
          }
  
  
          this.getBestCameras(this.activeAction2, this.pageBestCameras, filter)
          //this.getWorstCameras(this.activeAction2)
        },
  
  
        chartVideoLive(){
              var ctx = document.getElementById('videoLiveChart').getContext('2d');
              this.videoLiveChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [ this.livePassthrough, this.liveEncodings ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "Live:",
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                          display:true
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartVideoLive(){
            this.videoLiveChart.data.datasets[0].data=[ this.livePassthrough, this.liveEncodings ];
            this.videoLiveChart.options.title.text = this.videoLiveChart.options.title.text.split(':')[0] + ': ' + (this.livePassthrough + this.liveEncodings)
            this.videoLiveChart.update()
        },
        chartVideoVod(){
              var ctx = document.getElementById('videoVodChart').getContext('2d');
              this.videoVodChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [ this.VODPassthrough, this.VODEncodings ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "VoD:",
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartVideoVod(){
            this.videoVodChart.data.datasets[0].data=[ this.VODPassthrough, this.VODEncodings ];
            this.videoVodChart.options.title.text = this.videoVodChart.options.title.text.split(':')[0] + ': ' + (this.VODPassthrough + this.VODEncodings)
            this.videoVodChart.update()
        },
        chartVideoAll(){
              var ctx = document.getElementById('videoAllChart').getContext('2d');
              this.videoAllChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [ this.VODPassthrough + this.livePassthrough, this.VODEncodings + this.liveEncodings ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "All:",
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartVideoAll(){
            this.videoAllChart.data.datasets[0].data=[ this.VODPassthrough + this.livePassthrough, this.VODEncodings + this.liveEncodings];
            this.videoAllChart.options.title.text = this.videoAllChart.options.title.text.split(':')[0] + ': ' + (this.VODPassthrough + this.VODEncodings + this.livePassthrough + this.liveEncodings)
            this.videoAllChart.update()
        },
        chartCameraLive(){
              var ctx = document.getElementById('cameraLiveChart').getContext('2d');
              this.cameraLiveChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [ this.keyTypeLivePassthrough, this.keyTypeLiveEncoding ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "Live: " + (this.keyTypeLivePassthrough + this.keyTypeLiveEncoding),
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                          display:true
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartCameraLive(){
            this.cameraLiveChart.data.datasets[0].data=[ this.keyTypeLivePassthrough, this.keyTypeLiveEncoding ];
            this.cameraLiveChart.options.title.text = this.cameraLiveChart.options.title.text.split(':')[0] + ': ' + (this.keyTypeLivePassthrough + this.keyTypeLiveEncoding)
            this.cameraLiveChart.update()
        },
        chartCameraVod(){
              var ctx = document.getElementById('cameraVodChart').getContext('2d');
              this.cameraVodChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [ this.keyTypeVodPassthrough, this.keyTypeVodEncoding ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "VoD: " + (this.keyTypeVodPassthrough + this.keyTypeVodEncoding),
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                          display:true
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartCameraVod(){
            this.cameraVodChart.data.datasets[0].data=[ this.keyTypeVodPassthrough, this.keyTypeVodEncoding ];
            this.cameraVodChart.options.title.text = this.cameraVodChart.options.title.text.split(':')[0] + ': ' + (this.keyTypeVodPassthrough + this.keyTypeVodEncoding)
            this.cameraVodChart.update()
        },
        chartCameraBoth(){
              var ctx = document.getElementById('cameraBothChart').getContext('2d');
              this.cameraBothChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [ this.keyTypeLVPassthrough, this.keyTypeLVEncoding ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "Live+VoD: " + (this.keyTypeLVPassthrough + this.keyTypeLVEncoding),
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                          display:true
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartCameraBoth(){
            this.cameraBothChart.data.datasets[0].data=[ this.keyTypeLVPassthrough, this.keyTypeLVEncoding ];
            this.cameraBothChart.options.title.text = this.cameraBothChart.options.title.text.split(':')[0] + ': ' + (this.keyTypeLVPassthrough + this.keyTypeLVEncoding)
            this.cameraBothChart.update()
        },
  
        chartCameraAll(){
              var ctx = document.getElementById('cameraAllChart').getContext('2d');
              this.cameraAllChart = new Chart(ctx, {
                  type: 'doughnut',
                  data: {
                      labels:['passthrough','encoding'],
                      datasets: [{
                          label: '',
                          data: [this.keyTypeLVPassthrough + this.keyTypeLivePassthrough + this.keyTypeVodPassthrough, this.keyTypeLVEncoding + this.keyTypeLiveEncoding + this.keyTypeVodEncoding ],
                          backgroundColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderColor: [
                              '#E0B400',
                              '#00b0ff',
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      title: {
                          text: "All: " + (this.keyTypeLVPassthrough + this.keyTypeLivePassthrough + this.keyTypeVodPassthrough + this.keyTypeLVEncoding + this.keyTypeLiveEncoding + this.keyTypeVodEncoding),
                          display:true
                      },
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                          position:'bottom',
                          display:true
                      },
                      animation:{
                          animationScale:true,
                          animationRotate:true
                      },
                      plugins: {
                          labels: {
                              render: 'value',
                              fontColor: ['white', 'white'],
                              precision: 2
                          },
                          datalabels: {
                              display:false
                          }
                      }
                  }
              });
        },
        updateChartCameraAll(){
            this.cameraAllChart.data.datasets[0].data=[ this.keyTypeLVPassthrough + this.keyTypeLivePassthrough + this.keyTypeVodPassthrough, this.keyTypeLVEncoding + this.keyTypeLiveEncoding + this.keyTypeVodEncoding ];
            this.cameraAllChart.options.title.text = this.cameraAllChart.options.title.text.split(':')[0] + ': ' + (this.keyTypeLVPassthrough + this.keyTypeLivePassthrough + this.keyTypeVodPassthrough + this.keyTypeLVEncoding + this.keyTypeLiveEncoding + this.keyTypeVodEncoding)
            this.cameraAllChart.update()
        },
  
        
  
  
  
  
  
  
  
  
  
  
  
  
  
        chartBestCamera(){
              var ctx = document.getElementById('myChart8').getContext('2d');
              this.myChart8 = new Chart(ctx, {
                  
                  type: 'bar',
                  data: {
                      labels:[],
                      datasets: [{
                          data: [ ],
                          backgroundColor: "#ff0037",
                          borderWidth: 1
                      }]
                  },
                  options: {
                      animation: false,
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                        display:false  
                      },
                      title:{
                          display:true,
                          text:'Best camera'
                      },
                      scales:{
                          yAxes:[{
                              scaleLabel:{
                                  labelString:'Data delivered (GB)',
                                  display:true
                              },
                              type:'linear',
                              display:true,
                              position:'left',
                              ticks:{
                                  min:0,
                                  suggestedMax:5
                              }
                              
                          }]
                      },
                      plugins: {
                          labels: {
                              render: 'value'
                          },
                          datalabels: {
                              display:false
                          }
                      }
  
                  }
                  
              });
        },
        updateChartBestCamera(){
            this.myChart8.update()
        },
        chartWorstCamera(){
              var ctx = document.getElementById('myChart9').getContext('2d');
              this.myChart9 = new Chart(ctx, {
                  type: 'bar',
                  data: {
                      labels:[],
                      datasets: [{
                          data: [],
                          backgroundColor: [
  
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      responsive:true,
                      legend:{
                        display:false  
                      },
                      title:{
                          display:true,
                          text:'Worst camera'
                      },
                      scales:{
                          yAxes:[{
                              scaleLabel:{
                                  labelString:'Data delivered (GB)',
                                  display:true
                              },
                              type:'linear',
                              display:true,
                              position:'left',
                              ticks:{
                                  min:0,
                                  suggestedMax:5
                              }
                              
                          }]
                      },
                      plugins: {
                          labels: {
                              render: 'value'
                          },
                          datalabels: {
                              display:false
                          }
                      }
  
                  }
                  
              });
        },
        updateChartWorstCamera(){
            this.myChart9.update()
        },
        chartKeyType(){
              var ctx = document.getElementById('myChart10').getContext('2d');
              this.myChart10 = new Chart(ctx, {
                  type: 'bar',
                  data: {
                      labels:['live','vod','live + vod'],
                      datasets: [{
                          data: [ this.keyTypeLive, this.keyTypeVod, this.keyTypeLV ],
                          backgroundColor: [
                              '#ff0037',
                              'rgba(0,176,247)',
                              '#8556F1'
  
                          ],
                          borderWidth: 1
                      }]
                  },
                  options: {
                      responsive:true,
                      maintainAspectRatio: false,
                      legend:{
                        display:false  
                      },
                      title:{
                          display:true,
                          text:'Key Type'
                      },
                      scales:{
                          yAxes:[{
                              scaleLabel:{
                                  labelString:'Number of',
                                  display:true
                              },
                              type:'linear',
                              display:true,
                              position:'left',
                              ticks:{
                                  min:0,
                                  suggestedMax:5
                              }
                              
                          }]
                      },
                      plugins: {
                          labels: {
                             fontSize:0
                          },
                          datalabels: {
                              color:'white'
                          }
                      }
  
                  }
                  
              });
        },
        updateChartKeyType(){
            this.myChart10.data.datasets[0].data=[ this.keyTypeLive, this.keyTypeVod, this.keyTypeLV ]
            this.myChart10.update()
        },
        // Request API to get the best cameras Tab
        getBestCameras(param, page, filter){
            return new Promise((resolve, reject) =>{
              this.isGetInProgress=true
              analyticsService.getBestCameras(param, this.clientView, this.$auth.token(), this.numberOfCameras, page, this.intervalBestCameras, filter).then(response=>{
                  let n
                  this.bestCamera=[]
                  this.myChart8.data.labels=[]
                  this.myChart8.data.datasets[0].data=[]
                  this.myChart8.data.datasets[0].backgroundColor=[]
                  this.maxPageBestCameras = Math.ceil(response.data._size / this.numberOfCameras)
                  for(n=0;n<response.data._embedded.length;n++){
                      this.bestCamera.push(response.data._embedded[n])
                      this.myChart8.data.labels.push(response.data._embedded[n].key)
                      this.myChart8.data.datasets[0].backgroundColor.push('rgba(0,176,247)');
                      var off = Math.round(response.data._embedded[n][`offload_${this.intervalBestCameras}`] * 10) / 10;
                      if(this.isActive2==1){
                          this.myChart8.data.datasets[0].data.push(response.data._embedded[n][`nbView_${this.intervalBestCameras}`])
                          this.myChart8.data.labels.pop();
                          this.myChart8.data.labels.push(response.data._embedded[n].key + ' (' + off + ' % P2P)')
                      }
                      else if(this.isActive2==2){
                          this.myChart8.data.datasets[0].data.push(Math.round(response.data._embedded[n][`hourview_${this.intervalBestCameras}`]))
                      }
                      else if(this.isActive2==3){
                          this.myChart8.data.datasets[0].data.push(Math.round(response.data._embedded[n][`meanTime_${this.intervalBestCameras}`]))
                      }
                      else if(this.isActive2==4){
                          this.myChart8.data.datasets[0].data.push(response.data._embedded[n][`rebuff_${this.intervalBestCameras}`])
                      }
                      else if(this.isActive2==5){
                          this.myChart8.data.datasets[0].data.push(off)
                          this.myChart8.data.labels.pop();
                          this.myChart8.data.labels.push(response.data._embedded[n].key + ' (' + response.data._embedded[n][`nbView_${this.intervalBestCameras}`] + ' vues)')
                      }
                      else if(this.isActive2==6){
                          this.myChart8.data.datasets[0].data.push(response.data._embedded[n][`bitrate_${this.intervalBestCameras}`])
                      }
                      else if(this.isActive2==7){
                          this.myChart8.data.datasets[0].data.push(Math.round(response.data._embedded[n][`dataDelivered_${this.intervalBestCameras}`]))
                      } else if(this.isActive2==8){
                          this.myChart8.data.datasets[0].data.push(Math.round(response.data._embedded[n][`encodingError_${this.intervalBestCameras}`]))
                      }
                  }
                  if(this.isActive2==1){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="Views"
                  }
                  else if(this.isActive2==2){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="Time (hour)"
                  }
                  else if(this.isActive2==3){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="Time (secondes)"
                  }
                  else if(this.isActive2==4){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="%"
                  }
                  else if(this.isActive2==5){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="%"
                  }
                  else if(this.isActive2==6){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="Mb/sec"
                  }
                  else if(this.isActive2==7){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="GB"
                  } else if(this.isActive2==8){
                      this.myChart8.options.scales.yAxes[0].scaleLabel.labelString="Errors"
                  }
                  this.isGetInProgress=false
                  
  
  
                  /*var xAxisLabelMinWidth = 50;
                  var chartCanvas = document.getElementById('myChart8');
                  var maxWidth = chartCanvas.parentElement.parentElement.clientWidth;
                  var width = Math.max(this.myChart8.data.labels.length * xAxisLabelMinWidth, maxWidth);
                  chartCanvas.parentElement.style.width = width +'px';*/
  
                  this.myChart8.update()
                  return resolve(true)
              })
            })
        },
        // Request API to get the worst cameras Tab
        getWorstCameras(param){
            this.isGetInProgress2=true
            analyticsService.getWorstCameras(param, this.clientView, this.$auth.token(), this.numberOfCameras).then(response=>{
                let n
                this.worstCamera=[]
                this.myChart9.data.labels=[]
                this.myChart9.data.datasets[0].data=[]
                this.myChart9.data.datasets[0].backgroundColor=[]
                for (n=0; n<response.data._embedded.length; n++) {
                  this.worstCamera.push(response.data._embedded[n])
                  this.myChart9.data.labels.push(response.data._embedded[n].key)
                  //this.myChart9.data.datasets[0].backgroundColor.push('#ff0037')
                  if(this.isActive2==1){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].nbView)
                  }
                  else if(this.isActive2==2){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].hourview)
                  }
                  else if(this.isActive2==3){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].meanTime)
                  }
                  else if(this.isActive2==4){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].rebuff)
                  }
                  else if(this.isActive2==5){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].offload)
                  }
                  else if(this.isActive2==6){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].bitrate)
                  }
                  else if(this.isActive2==7){
                      this.myChart9.data.datasets[0].data.push(response.data._embedded[n].dataDelivered)
                  }
                }
                if(this.isActive2==1){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="Views"
                }
                else if(this.isActive2==2){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="Time (hour)"
                }
                else if(this.isActive2==3){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="Time (secondes)"
                }
                else if(this.isActive2==4){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="%"
                }
                else if(this.isActive2==5){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="%"
                }
                else if(this.isActive2==6){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="Mb/sec"
                }
                else if(this.isActive2==7){
                    this.myChart9.options.scales.yAxes[0].scaleLabel.labelString="GB"
                }
                this.isGetInProgress2=false
                this.myChart9.update()
            })
        },
        // Request to elasticsearch
        getGlobalAnalytics(date){
          analyticsService.getAllGlobalAnalytics(date, this.$auth.getMyUser().username).then(response=>{
            this.totNbVues=response.data.aggregations.tot_nbVues.value
            this.totDataDelivered=Math.round(response.data.aggregations.tot_data_delivered.value/1000000)
            var Time=response.data.aggregations.tot_hours_view.value
            this.totHoursView=Math.floor(Time)
            var hour= Math.abs(Time);
            var decimal = hour - Math.floor(hour)
            this.minuteView=Math.floor(decimal*60)
            let sec_server=response.data.aggregations.tot_sec_server.value
            let sec_rebuf=response.data.aggregations.tot_sec_rebuf.value
            let sec_peer=response.data.aggregations.tot_sec_peer.value
            let mb_peer=response.data.aggregations.tot_mb_peer.value
            this.sec_server=sec_server;
            this.sec_peer=sec_peer;
            let mb_server=response.data.aggregations.tot_mb_server.value
            let percent_sec_rebuf=100*sec_rebuf/(sec_rebuf+sec_server+sec_peer);
            let percent_offload=Math.round((100*mb_peer/(mb_peer+mb_server)) * 10) / 10;
            if (isNaN(percent_sec_rebuf)){
                  this.percent_rebuf=0
            }
            else{
                  this.percent_rebuf=Math.round(percent_sec_rebuf);
            }
            if (isNaN(percent_offload)){
                  this.percent_off=0
            }
            else{
                  this.percent_off=Math.round(percent_offload);
            }
              this.updateChartPercentRebuf()
              this.updateChartPercentOffload()
              this.updateChartNumberOf()
              this.updateChartViewData()
              this.updateChartTimeInfo()
              this.updateChartTimeVodInfo()
              this.updateChartBitrate()
              this.updateChartBestCamera()
              this.updateChartWorstCamera()
              this.updateChartKeyType()
          })
        
        },
        //Request to the api to get several numbers
      getNumberVideoPlatform(){
          this.totalVideo=0
          this.livePassthrough=0
          this.liveEncodings=0
          this.VODPassthrough=0;
          this.VODEncodings=0
  
          
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'live', encoding: 'passthrough', client: this.clientView})}).then(videos => {
              this.livePassthrough=videos._size
              this.updateChartVideoLive()
              this.updateChartVideoAll()
          })
      
  
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({ type: 'live', encoding: 'encoding', client: this.clientView})}).then(videos => {
              this.liveEncodings=videos._size
              this.updateChartVideoLive()
              this.updateChartVideoAll()
          })
      
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'vod', encoding: 'passthrough', client: this.clientView})}).then(videos => {
              this.VODPassthrough=videos._size
              this.updateChartVideoVod()
              this.updateChartVideoAll()
          })
      
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'vod', encoding: 'encoding', client: this.clientView})}).then(videos => {
              this.VODEncodings=videos._size
              this.updateChartVideoVod()
              this.updateChartVideoAll()
          })
  
  
  
  
  
  
  
          authorizationKeyService.getAuthorizationKeys(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'vod', encoding: 'encoding', client: this.clientView})}).then(keys => {
              this.keyTypeVodEncoding=keys._size
              this.updateChartCameraVod()
              this.updateChartCameraAll()
          })
  
          authorizationKeyService.getAuthorizationKeys(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'vod', encoding: 'passthrough', client: this.clientView})}).then(keys => {
              this.keyTypeVodPassthrough=keys._size
              this.updateChartCameraVod()
              this.updateChartCameraAll()
          })
  
          authorizationKeyService.getAuthorizationKeys(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'live', encoding: 'encoding', client: this.clientView})}).then(keys => {
              this.keyTypeLiveEncoding=keys._size
              this.updateChartCameraLive()
              this.updateChartCameraAll()
          })
  
          authorizationKeyService.getAuthorizationKeys(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'live', encoding: 'passthrough', client: this.clientView})}).then(keys => {
              this.keyTypeLivePassthrough=keys._size
              this.updateChartCameraLive()
              this.updateChartCameraAll()
          })
  
          authorizationKeyService.getAuthorizationKeys(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: "live-vod", encoding: 'encoding', client: this.clientView})}).then(keys => {
              this.keyTypeLVEncoding=keys._size
              this.updateChartCameraBoth()
              this.updateChartCameraAll()
          })
  
          authorizationKeyService.getAuthorizationKeys(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({type: 'live-vod', encoding: 'passthrough', client: this.clientView})}).then(keys => {
              this.keyTypeLVPassthrough=keys._size
              this.updateChartCameraBoth()
              this.updateChartCameraAll()
          })
  
          
          
          /*videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0}).then(videos => {
              this.totalVideo=videos._size
              this.updateChartNumberOf()
          })*/
  
          //Key type
          /*videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({ keyType: 'live-only', encoding: 'passthrough'})}).then(videos => {
              this.keyTypeLivePassthrough=videos._size;
  
          })
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({ keyType: 'live-only', encoding: 'encoding'})}).then(videos => {
              this.keyTypeLiveEncoding=videos._size;
  
          })
      
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({keyType: 'vod-only', encoding: 'passthrough'})}).then(videos => {
              this.keyTypeVodPassthrough=videos._size;
  
          })
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({keyType: 'vod-only', encoding: 'encoding'})}).then(videos => {
              this.keyTypeVodEncoding=videos._size;
  
          })
      
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({ keyType: 'live+vod', encoding: 'passthrough'})}).then(videos => {
              this.keyTypeLVPassthrough=videos._size;
          })
          videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0, filter:JSON.stringify({ keyType: 'live+vod', encoding: 'encoding'})}).then(videos => {
              this.keyTypeLVEncoding=videos._size;
          })*/
          
  
        }
    }
  }
  </script>